"use client";

import { Input } from "@workspace/ui/components/input";
import { Textarea } from "@workspace/ui/components/textarea";

interface TextFieldProps {
  value?: string;
  editing?: boolean;
  onChange?: (value: string) => void;
  multiline?: boolean;
}

export function TextField({
  value,
  editing,
  onChange,
  multiline = false,
}: TextFieldProps) {
  if (!editing) {
    return value ? (
      <span className="text-sm text-foreground line-clamp-3">{value}</span>
    ) : (
      <span className="text-sm text-muted-foreground italic">—</span>
    );
  }

  if (multiline) {
    return (
      <Textarea
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
        className="text-sm min-h-[60px] px-2 py-1.5"
        rows={2}
      />
    );
  }

  return (
    <Input
      value={value || ""}
      onChange={(e) => onChange?.(e.target.value)}
      className="h-8 text-sm px-2"
    />
  );
}
